import { jsx, jsxs } from "react/jsx-runtime";
import { QuestionnaireAnswerFormat } from "./NeedsBasedQuestions.types.js";
import NeedsBasedQuestion from "./NeedsBasedQuestion/NeedsBasedQuestion.js";
function NeedsBasedQuestions({
  updateAnswers,
  answers,
  needsBasedQuestionsAPI,
  QuestionComponent,
  ScriptingContainer,
  hasError
}) {
  const parentQuestions = (needsBasedQuestionsAPI == null ? void 0 : needsBasedQuestionsAPI.filter((question) => {
    var _a;
    return ((_a = question.triggers) == null ? void 0 : _a.length) === 0 || question.triggers === null;
  })) || [];
  function findQuestionById(questionId) {
    return needsBasedQuestionsAPI == null ? void 0 : needsBasedQuestionsAPI.find((q) => (q == null ? void 0 : q.questionId) === questionId);
  }
  const handleButtonClick = (selectedButtons, questionId, parentQuestionId) => {
    var _a, _b;
    const isParentQuestionClicked = parentQuestionId === void 0;
    const isMultiCheckList = Array.isArray(selectedButtons);
    const selectedQuestionAnswers = (_a = findQuestionById(questionId)) == null ? void 0 : _a.answer;
    const selectedQuestionAnswersArray = selectedQuestionAnswers == null ? void 0 : selectedQuestionAnswers.answers;
    const selectedQuestionAnswersIds = selectedQuestionAnswersArray == null ? void 0 : selectedQuestionAnswersArray.map((q) => q.answerId);
    const hasNoneButton = (selectedQuestionAnswers == null ? void 0 : selectedQuestionAnswers.format) === QuestionnaireAnswerFormat.CheckBoxListNone;
    const noneButton = (
      // noneButton is by convention the last answer in the array, and it will reset/deselect all previous answers
      hasNoneButton && ((_b = selectedQuestionAnswersArray == null ? void 0 : selectedQuestionAnswersArray[selectedQuestionAnswersArray.length - 1]) == null ? void 0 : _b.answerId) || null
    );
    updateAnswers((prevState) => {
      const updatedState = { ...prevState };
      const isNoneBtnSelected = isMultiCheckList && noneButton && selectedButtons.some((val) => val === noneButton) && !prevState[questionId].includes(noneButton);
      const isNoneBtnUnselectedByOtherBtn = isMultiCheckList && noneButton && selectedButtons.length > 1 && prevState[questionId].includes(noneButton) && prevState[questionId].length === 1;
      if (isNoneBtnSelected) {
        updatedState[questionId] = [noneButton];
      } else if (isNoneBtnUnselectedByOtherBtn) {
        updatedState[questionId] = selectedButtons.filter((val) => val !== noneButton);
      } else if (isMultiCheckList && isParentQuestionClicked) {
        updatedState[questionId] = selectedButtons;
        selectedButtons.forEach((selectedAnswer) => {
          if (findQuestionById(selectedAnswer)) {
            updatedState[selectedAnswer] = updatedState[selectedAnswer] || "";
          }
        });
      } else {
        updatedState[questionId] = selectedButtons;
      }
      if (isParentQuestionClicked) {
        if (isNoneBtnSelected) {
          selectedQuestionAnswersIds == null ? void 0 : selectedQuestionAnswersIds.forEach((id) => {
            delete updatedState[id];
          });
        } else {
          for (const key in updatedState) {
            if ((selectedQuestionAnswersIds == null ? void 0 : selectedQuestionAnswersIds.includes(key)) && !selectedButtons.includes(key)) {
              delete updatedState[key];
            }
          }
        }
      }
      return updatedState;
    });
  };
  return /* @__PURE__ */ jsx("div", { "data-test-id": "section_needs_based_questions_container", children: parentQuestions.map((parentQuestion) => {
    var _a;
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(
        NeedsBasedQuestion,
        {
          questionId: parentQuestion.questionId,
          description: parentQuestion.description,
          answer: parentQuestion.answer,
          onChangeCallback: handleButtonClick,
          value: answers[parentQuestion.questionId],
          QuestionComponent,
          ScriptingContainer,
          required: parentQuestion.answerRequired,
          hasError
        }
      ),
      Array.isArray(answers[parentQuestion.questionId]) && ((_a = answers[parentQuestion.questionId]) == null ? void 0 : _a.map((childId) => {
        const childQuestion = findQuestionById(childId);
        return childQuestion ? /* @__PURE__ */ jsx(
          NeedsBasedQuestion,
          {
            questionId: childQuestion.questionId,
            parentQuestionId: parentQuestion.questionId,
            description: childQuestion.description,
            answer: childQuestion.answer,
            onChangeCallback: handleButtonClick,
            value: answers[childQuestion.questionId],
            QuestionComponent,
            ScriptingContainer,
            required: childQuestion.answerRequired,
            hasError
          },
          childQuestion.questionId
        ) : null;
      }))
    ] }, parentQuestion.questionId);
  }) });
}
export {
  NeedsBasedQuestions as default
};
